<ridango-basic-notifications-container [locale]="locale"></ridango-basic-notifications-container>
<div class="bank-card-container">
    <div class="p-4" *ngIf="!displayIframe">
        <h1>{{ 'ADD_BANK_CARD_HEADER' | translate }}</h1>
        <p [innerHTML]="'ADD_BANK_CARD_DESCRIPTION' | translate"></p>
    </div>
    <iframe
        class="full-width"
        id="ecomm3"
        #iframe
        *ngIf="(ticketsLoading$ | async) === false && displayIframe && (ticketsError$ | async) === null"
        [src]="tpsEndpoint | safeResourceUrl"
        style="border: none; height: 100%"
        name="ecomm3"></iframe>
</div>
